// extracted by mini-css-extract-plugin
module.exports = {"chatButton":"Chat_pc_chatButton__HKHoP","button":"Chat_pc_button__IRrgc"};